import isMobile from 'ismobilejs';

export const useCheckMobile = () => {
  return isMobile(window.navigator).any;
};
